<table
  mat-table
  matSort
  data-test-id="request-additional-availability-interview-period-table"
  [dataSource]="dataSource()"
>
  <ng-container matColumnDef="date">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Date</th>
    <td
      *matCellDef="let element"
      mat-cell
      data-test-id="request-additional-availability-interview-period-table-date"
    >
      {{ element.date | date: 'longDate' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="start">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Start</th>
    <td
      *matCellDef="let element"
      mat-cell
      data-test-id="request-additional-availability-interview-period-table-start"
    >
      {{ element.start }}
      @if (element.expertPerspective) {
        <span
          class="text-[#ccc]"
          [matTooltip]="element.expertPerspective.tooltip"
        >
          ({{ element.expertPerspective.start }})
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="end">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>End</th>
    <td
      *matCellDef="let element"
      mat-cell
      data-test-id="request-additional-availability-interview-period-table-end"
    >
      {{ element.end }}
      @if (element.expertPerspective) {
        <span
          class="text-[#ccc]"
          [matTooltip]="element.expertPerspective.tooltip"
        >
          ({{ element.expertPerspective.end }})
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th *matHeaderCellDef mat-header-cell></th>
    <td
      *matCellDef="let element; let idx = index"
      mat-cell
      data-test-id="request-additional-availability-interview-period-table-actions"
    >
      <div class="flex flex-row justify-end items-center">
        @if (element.isPreferred) {
          <mat-icon class="text-[#f7be10]" matTooltip="Preferred">
            star
          </mat-icon>
        }
        <span
          matTooltip="Use the project settings to remove existing times from the interview period"
          data-test-id="request-additional-availability-interview-period-table-remove"
          [matTooltipDisabled]="element.allowDelete"
        >
          <button
            mat-icon-button
            type="button"
            [attr.aria-label]="`Remove time ${element.date} ${element.start} to ${element.end}`"
            [disabled]="!element.allowDelete"
            (click)="remove(element)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </span>
      </div>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr
    *matRowDef="let row; columns: displayedColumns"
    mat-row
    data-test-id="request-additional-availability-interview-period-table-row"
  ></tr>
  <tr
    *matNoDataRow
    class="mat-mdc-row"
    data-test-id="request-additional-availability-interview-period-table-loading-row"
  >
    @if (isLoading()) {
      @for (column of displayedColumns; track column) {
        @if (column !== 'actions') {
          <td class="mat-mdc-cell">
            <app-skeleton-block width="60%" />
          </td>
        }
      }
    }
  </tr>
</table>
<mat-paginator showFirstLastButtons [pageSize]="5" />
